import React from 'react'
import { createResource, useResource } from '@/lib/i18n'
import styled from 'styled-components'
import { Animation, Reveal } from 'react-genie'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const Footer = dynamic(import('@/components/home/footer'))
const KPHead = dynamic(import('@/components/head'))
const TopNavigation = dynamic(import('@/components/top-navigation'))

const resource = createResource({
  en: {
    contentTitle: 'Kredit Pintar Disclaimer',
    description:
      'All services are provided following the applicable information security policy and set by Kredit Pintar, a money loan service provider.',
    contentSubTitle:
      'As a commitment of Kredit Pintar to implement Information Security, hereby is the Information Security Policy that we already set',
    section1:
      "Fulfilling the Stakeholders' expectations by implementing Confidentiality, Integrity, and Availability of information through the implementation of ISO/IEC 27001 ISMS.",
    section2:
      'Always obey every valid term and regulation related to information security in the Republic of Indonesia along where the business is done.',
    section3:
      'Progressive improvement that is synchronous with the performance of the Information Security Management System.',
    section4:
      'TKB 90 is a success benchmark of the peer-to-peer financial technology lending organizer in facilitating lending-borrowing settlement responsibility in 90 days period of time since the due date.',
  },
  id: {
    contentTitle: 'Kredit Pintar Disclaimer',
    description:
      'Seluruh layanan diberikan mengikuti kebijakan keamanan informasi yang berlaku dan ditetapkan oleh Kredit Pintar, penyedia layanan pinjaman uang.',
    contentSubTitle:
      'Dalam hal bentuk komitmen kredit pintar dalam penerapan Keamanan Informasi, berikut adalah Kebijakan Keamanan Informasi yang kami tetapkan',
    section1:
      'Memenuhi harapan Stakeholder dengan mewujudkan Confidentiality, Integrity dan Availlability informasi melalui implementasi ISO/IEC 27001 ISMS.',
    section2:
      'Selalu mentaati segala ketentuan dan peraturan terkait keamanan informasi yang berlaku di wilayah Republik Indonesia serta wilayah tempat dilakukannya pekerjaan.',
    section3: 'Berjalannya perbaikan yang berkesinambungan terhadap kinerja Sistem Manajemen Keamananan Informasi.',
    section4:
      'TKB90 adalah ukuran tingkat keberhasilan penyelenggara Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 90 hari sejak tanggal jatuh tempo',
  },
})

const Disclaimer = () => {
  const { t } = useResource(resource)
  return (
    <DisclaimerStyle>
      <Reveal animation={Animation.FadeIn}>
        <KPHead metaTitle="disclaimer" />
        <Head>
          <meta name="description" content={t('description')} />
        </Head>
        <TopNavigation />
        <div className="disclaimer">
          <h1 className="title">{t('contentTitle')}</h1>
          <div className="content">
            <div>
              <div>{t('contentSubTitle')}:</div>
              <div>
                <span>1. </span>
                {t('section1')}
              </div>
              <div>
                <span>2. </span>
                {t('section2')}
              </div>
              <div>
                <span>3. </span>
                {t('section3')}
              </div>
              <div>
                <span>4. </span>
                {t('section4')}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Reveal>
    </DisclaimerStyle>
  )
}

export default Disclaimer

const DisclaimerStyle = styled.div`
  width: 100%;
  min-height: 30vh;
  @media only screen and (max-width: 1000px) {
    .disclaimer {
      margin: 0 auto;
      padding: 78px 24px;
      .title {
        margin: 32px 0 24px;
        text-align: center;
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
      }
      .content {
        display: block !important;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 24px;
        div {
          padding-bottom: 12px;
          span {
            color: #212121;
            font-family: Roboto-Bold, Roboto;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .disclaimer {
      max-width: 1140px;
      margin: 0 auto;
      padding: 82px 0;
      border-bottom: 1px solid #eee;
      .title {
        margin: 80px 0 40px;
        text-align: center;
        font-size: 36px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
      }
      .content {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 24px;
        div {
          padding-bottom: 20px;
          span {
            color: #212121;
            font-family: Roboto-Bold, Roboto;
          }
        }
      }
    }
  }

  .three {
    padding: 0;
    border: 0;
  }
`
